import React, { Suspense } from "react";
import { MatxLoading } from ".";

const Loadable =
    <T extends React.ComponentType<any>>(Component: T) =>
    (props: React.ComponentProps<T>) => {
        return (
            <Suspense fallback={<MatxLoading />}>
                <Component {...props} />
            </Suspense>
        );
    };

export default Loadable;
